import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex align-items-center" }
const _hoisted_2 = { class: "title white-space-nowrap" }

import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PoolTitle',
  props: {
    tokenName: null,
    isSyrup: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tokenName?: string;
  isSyrup: boolean;
}


const { t } = useI18n();
const title = computed(() =>
  t(`yieldPool.manual.poolTitle.${props.isSyrup ? 'syrup' : 'blues'}.caption`, {
    name: props.tokenName,
  }),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(title)), 1),
    (!__props.isSyrup)
      ? (_openBlock(), _createBlock(TooltipIcon, {
          key: 0,
          tooltip: _unref(t)(`yieldPool.manual.poolTitle.blues.tooltip`)
        }, null, 8, ["tooltip"]))
      : _createCommentVNode("", true)
  ]))
}
}

})